<div class="subheader with-padding flgrow" style="position: relative;">
    <div class="d-flex align-items-center">
        <div class="row align-items-center flex flex-grow-1">
            <div class="col-lg-3 col-md-6 col-sm-8 maxw600">
                <div class="input-group">
                    <input class="form-control" type="text" name="searchTerm"
                        placeholder="{{ 'lblQuicksearch' | translate }}" [(ngModel)]="searchTerm"
                        autocomplete="off" (ngModelChange)="onQuickSearch()" />
                    <div class="input-group-append">
                        <button type="button" class="btn btn-primary" (click)="onQuickSearch()"
                            aria-label="Center Align">
                            <em class="fa fa-search" aria-hidden="true"></em>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-auto pl-0">
                <div class="date filter-field">
                    <input bsDaterangepicker name="DateRange" [bsConfig]="myDateRangePickerOptions"
                        class="form-control" placeholder="{{ 'lblBookedDateRange' | translate }}"
                        [(ngModel)]="dateRange" (ngModelChange)="onDateRangeChange()" required />
                </div>
            </div>
            <div class="col-auto pl-0">
                <div class="filter-field">
                    <select class="form-control" name="statusFilter" [(ngModel)]="selectedStatus"
                        (ngModelChange)="onStatusFilterChange()">
                        <option [ngValue]="null">{{ 'lblAllStatuses' | translate }}</option>
                        <option *ngFor="let status of statusList" [ngValue]="status.value">{{ status.text | translate }}</option>
                    </select>
                </div>
            </div>
            <div class="col-auto pl-0">
                <button type="button" class="btn btn-outline-tertiary" (click)="onReset()" translate
                    aria-label="Center Align">lblReset</button>
            </div>
        </div>
        <div class="pl-2 d-flex align-items-center flex-sm-row flex-column justify-content-end ml-auto">
            <a class="btn btn-outline-primary" href="javascript:void(0);" (click)="getReportList()"
                aria-label="Center Align">
                <em class="fas fa-sync fa-lg"></em>
            </a>
        </div>
    </div>
</div>

<div class="container prel">
    <div class="row">
        <div class="c12">
            <div class="kpi-grid mb-3">
                <div class="kpi-card kpi-dark">
                    <span class="kpi-ico-box"><em class="fas fa-bug"></em></span>
                    <div class="kpi-body">
                        <div class="kpi-top">
                            <span class="kpi-label" translate>lblTotalSpikes</span>
                        </div>
                        <div class="kpi-value">{{ displayList.length }}</div>
                    </div>
                </div>
                <div class="kpi-card">
                    <span class="kpi-ico-box"><em class="fas fa-route"></em></span>
                    <div class="kpi-body">
                        <div class="kpi-top">
                            <span class="kpi-label" translate>lblAffectedEndpoints</span>
                        </div>
                        <div class="kpi-value">{{ stats.endpoints }}</div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-6 mb-3">
                    <div class="card h-100 chart-card">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <span translate>lblTopEndpoints</span>
                        </div>
                        <div class="card-body">
                            <div class="chart-scroll" *ngIf="endpointItems.length > 0; else noEndpoint">
                                <div class="svc-row" *ngFor="let item of endpointItems" [class.is-active]="selectedEndpoint === item.name"
                                    [class.is-dim]="selectedEndpoint && selectedEndpoint !== item.name"
                                    (click)="onEndpointClick(item.name, item.controllerName + ' / ' + item.methodName)">
                                    <span class="svc-fill" [style.width.%]="item.percent"></span>
                                    <span class="svc-name svc-endpoint" [title]="item.name">
                                        <span class="endpoint-name">{{ item.controllerName }}</span>
                                        <span class="endpoint-sub">{{ item.methodName }}</span>
                                    </span>
                                    <span class="svc-amount" ngbTooltip="{{ 'lblSpikes' | translate }}" placement="top"
                                        container="body">{{ item.spikes }}</span>
                                    <span class="svc-count" ngbTooltip="{{ 'lblOccurrences' | translate }}"
                                        placement="top" container="body">{{ item.count }}</span>
                                </div>
                            </div>
                            <ng-template #noEndpoint>
                                <div class="no-data" translate>lblNoRecordsFound</div>
                            </ng-template>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-3">
                    <div class="card h-100 chart-card">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <span translate>lblProbableCauses</span>
                        </div>
                        <div class="card-body">
                            <div class="chart-scroll" *ngIf="causeItems.length > 0; else noCause">
                                <div class="svc-row" *ngFor="let item of causeItems" [class.is-active]="selectedCause === item.name"
                                    [class.is-dim]="selectedCause && selectedCause !== item.name"
                                    (click)="onCauseClick(item.name)">
                                    <span class="svc-fill" [style.width.%]="item.percent"></span>
                                    <span class="svc-name" [title]="item.name">{{ item.name }}</span>
                                    <span class="svc-count">{{ item.count }}</span>
                                </div>
                            </div>
                            <ng-template #noCause>
                                <div class="no-data" translate>lblNoRecordsFound</div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container prel">
    <div class="row">
        <div class="c12">
            <div class="report-layout" [class.has-panel]="selectedItem">
                <div class="card mb-3 report-main">
                    <div class="card-header d-flex justify-content-between align-items-center flex-wrap">
                        <span class="report-title">
                            <span translate>lblErrorLogAnalysisReport</span>
                            <span class="report-count">({{ displayList.length }})</span>
                        </span>
                        <span class="filter-tags">
                            <span class="filter-tag" *ngIf="selectedEndpoint" [title]="selectedEndpointLabel"><span class="filter-tag-label"><span translate>lblController</span>:</span><span class="filter-tag-text">{{ selectedEndpointLabel }}</span>
                                <a href="javascript:void(0);" (click)="onEndpointClick(selectedEndpoint)" [attr.aria-label]="'lblClose' | translate"><em class="fas fa-times"></em></a></span>
                            <span class="filter-tag" *ngIf="selectedCause" [title]="selectedCause"><span class="filter-tag-label"><span translate>lblWhyIssueOccurred</span>:</span><span class="filter-tag-text">{{ selectedCause }}</span>
                                <a href="javascript:void(0);" (click)="onCauseClick(selectedCause)" [attr.aria-label]="'lblClose' | translate"><em class="fas fa-times"></em></a></span>
                        </span>
                    </div>

                    <div class="table-responsive max-h254">
                        <table class="tablest1">
                            <thead>
                                <tr>
                                    <th scope="col" translate>lblWindowStart</th>
                                    <th scope="col" translate>lblController</th>
                                    <th scope="col" translate>lblOccurrences</th>
                                    <th scope="col" translate>lblStatus</th>
                                    <th scope="col" class="qv-hideable" translate>lblParameterPattern</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="displayList.length > 0; else load_else">
                                    <tr class="report-row" *ngFor="let item of visibleList" [class.is-selected]="isSelected(item)"
                                        (click)="openPanel(item)">
                                        <td class="text-nowrap">{{ toLocalDate(item.windowStart) | date : 'dd.MM.yyyy, HH:mm' }}</td>
                                        <td>
                                            <a class="endpoint-link" href="javascript:void(0);" (click)="openEndpoint(item, $event)"
                                                ngbTooltip="{{ 'lblOpenEndpointDetails' | translate }}" placement="top" container="body">
                                                <div class="endpoint-name">{{ item.controllerName }}</div>
                                                <div class="endpoint-sub">{{ item.methodName }}</div>
                                            </a>
                                        </td>
                                        <td><span class="count-badge">{{ item.occurrenceCount }}</span></td>
                                        <td>
                                            <app-error-log-status-editor [item]="item"></app-error-log-status-editor>
                                        </td>
                                        <td class="qv-hideable">
                                            <span class="status-chip"
                                                [class.status-chip-warning]="item.isSameParameter"
                                                [class.status-chip-danger]="!item.isSameParameter">
                                                <em class="fas" [class.fa-equals]="item.isSameParameter"
                                                    [class.fa-random]="!item.isSameParameter"></em>
                                                <span>{{ (item.isSameParameter ? 'lblSameParameter' : 'lblDifferentParameters') | translate }}</span>
                                                <span *ngIf="!item.isSameParameter">({{ item.distinctParamCount }})</span>
                                            </span>
                                        </td>
                                    </tr>
                                </ng-container>
                                <ng-template #load_else>
                                    <tr>
                                        <td colspan="5" class="no-record" translate>
                                            lblNoRecordsFound
                                        </td>
                                    </tr>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex justify-content-between align-items-center">
                            <app-pagination [pager]="pager" [recordSize]="displayList.length" (setPageEvent)="setPage($event)"></app-pagination>
                            <div class="font16 fontbold">
                                <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{ displayList.length }}&nbsp;
                                <span class="font16 fontnormal" translate>lblResults</span>
                            </div>
                        </div>
                    </div>
                </div>

                <aside class="quick-view card mb-3" *ngIf="selectedItem" role="dialog" aria-modal="false"
                    [attr.aria-label]="'lblQuickView' | translate">
                    <div class="qv-head">
                        <div class="qv-toolbar">
                            <span class="qv-caption">
                                <span translate>lblQuickView</span> · {{ selectedIndex + 1 }} / {{ displayList.length }}
                            </span>
                            <button type="button" class="qv-btn" (click)="movePanel(-1)" [disabled]="selectedIndex <= 0"
                                [attr.aria-label]="'lblPrevious' | translate"><em class="fas fa-chevron-up"></em></button>
                            <button type="button" class="qv-btn" (click)="movePanel(1)"
                                [disabled]="selectedIndex >= displayList.length - 1"
                                [attr.aria-label]="'lblNext' | translate"><em class="fas fa-chevron-down"></em></button>
                            <button type="button" class="qv-btn" (click)="closePanel()"
                                [attr.aria-label]="'lblClose' | translate"><em class="fas fa-times"></em></button>
                        </div>
                        <a class="qv-title endpoint-link" href="javascript:void(0);" (click)="openEndpoint(selectedItem, $event)">
                            <div class="endpoint-name">{{ selectedItem.controllerName }}</div>
                            <div class="endpoint-sub">{{ selectedItem.methodName }}</div>
                        </a>
                        <div class="qv-status">
                            <div class="detail-title" translate>lblStatus</div>
                            <app-error-log-status-editor [item]="selectedItem" [editable]="true" (saved)="getReportList()"></app-error-log-status-editor>
                        </div>
                    </div>

                    <div class="qv-body">
                        <div class="insight-block insight-error">
                            <div class="insight-title">
                                <span><em class="fas fa-exclamation-circle"></em> <span translate>lblWhyIssueOccurred</span></span>
                                <button type="button" class="copy-btn" (click)="copy(getCauseText(selectedItem.cause))"
                                    [attr.aria-label]="'lblCopy' | translate" ngbTooltip="{{ 'lblCopy' | translate }}" container="body"><em class="far fa-copy"></em></button>
                            </div>
                            <div class="insight-text">{{ getCauseText(selectedItem.cause) }}</div>
                        </div>
                        <div class="insight-block insight-solution">
                            <div class="insight-title">
                                <span><em class="fas fa-lightbulb"></em> <span translate>lblProbableSolution</span></span>
                                <button type="button" class="copy-btn" (click)="copy(selectedItem.probableSolution)"
                                    [attr.aria-label]="'lblCopy' | translate" ngbTooltip="{{ 'lblCopy' | translate }}" container="body"><em class="far fa-copy"></em></button>
                            </div>
                            <div class="insight-text">{{ selectedItem.probableSolution }}</div>
                        </div>
                        <div class="insight-block insight-trace" *ngIf="getThrownAt(selectedItem.cause)">
                            <div class="insight-title">
                                <span><em class="fas fa-code"></em> <span translate>lblThrownAt</span></span>
                                <button type="button" class="copy-btn" (click)="copy(getThrownAt(selectedItem.cause))"
                                    [attr.aria-label]="'lblCopy' | translate" ngbTooltip="{{ 'lblCopy' | translate }}" container="body"><em class="far fa-copy"></em></button>
                            </div>
                            <pre class="insight-code">{{ getThrownAt(selectedItem.cause) }}</pre>
                        </div>
                        <div class="insight-block insight-pattern"
                            [class.insight-pattern-same]="selectedItem.isSameParameter">
                            <div class="insight-title">
                                <span><em class="fas" [class.fa-equals]="selectedItem.isSameParameter"
                                    [class.fa-random]="!selectedItem.isSameParameter"></em> <span translate>lblParameterPattern</span></span>
                                <button type="button" class="copy-btn" (click)="copy(selectedItem.parameterPattern)"
                                    [attr.aria-label]="'lblCopy' | translate" ngbTooltip="{{ 'lblCopy' | translate }}" container="body"><em class="far fa-copy"></em></button>
                            </div>
                            <div class="insight-text">{{ selectedItem.parameterPattern }}</div>
                        </div>

                        <div class="qv-section-title">
                            <span translate>lblOccurrences</span>
                            <span class="report-count">({{ panelTotal }})</span>
                        </div>
                        <app-error-log-occurrence-list [items]="panelOccurrences" [totalCount]="panelTotal"
                            [loading]="panelLoading" (loadMore)="loadPanelOccurrences(true)">
                        </app-error-log-occurrence-list>
                    </div>

                    <div class="qv-foot">
                        <button type="button" class="btn btn-primary btn-sm" (click)="openEndpoint(selectedItem, $event)"
                            translate>lblOpenEndpointDetails</button>
                    </div>
                </aside>
            </div>
        </div>
    </div>
</div>
